export const RETRO_HARDWARE = [
    {
  id: "atari-family",
  name: "Atari",
  brand: "Atari",
  type: "console",
  category: "Retro",
  variants: [
    {
      id: "atari-home",
      name: "Atari",
      versions: [
        {
          id: "atari-2600",
          name: "Atari 2600",
          storage: "",
          disc: false,
          image: "/images/consoles/atari-2600.png",
        },
        {
          id: "atari-5200",
          name: "Atari 5200",
          storage: "",
          disc: false,
          image: "/images/consoles/atari-5200.png",
        },
        {
          id: "atari-7800",
          name: "Atari 7800",
          storage: "",
          disc: false,
          image: "/images/consoles/atari-7800.png",
        },
        {
          id: "atari-jaguar",
          name: "Atari Jaguar",
          storage: "",
          disc: false,
          image: "/images/consoles/atari-jaguar.png",
        },
        {
          id: "atari-lynx",
          name: "Atari Lynx",
          storage: "",
          disc: false,
          image: "/images/consoles/atari-lynx.png",
        },
        {
            id: "atari-lynx-2",
            name: "Atari Lynx 2",
            storage: "",
            disc: false,
            image: "/images/consoles/atari-lynx-2.png",
        },
      ],
    },
  ],
},

{
  id: "nec-family",
  name: "PC Engine / TurboGrafx",
  brand: "NEC",
  type: "console",
  category: "Retro",
  variants: [
    {
      id: "pc-engine",
      name: "PC Engine",
      versions: [
        {
          id: "pc-engine-core",
          name: "PC Engine",
          storage: "",
          disc: false,
          image: "/images/consoles/pc-engine.png",
        },
        {
          id: "pc-engine-duo",
          name: "PC Engine Duo",
          storage: "",
          disc: true,
          image: "/images/consoles/pc-engine-duo.png",
        },
        {
          id: "turbografx-16",
          name: "TurboGrafx-16",
          storage: "",
          disc: false,
          image: "/images/consoles/turbografx-16.png",
        },
        {
          id: "pc-engine-mini",
          name: "PC Engine Mini",
          storage: "",
          disc: false,
          mini: true,
          image: "/images/consoles/pc-engine-mini.png",
        },
      ],
    },
  ],
},

{
  id: "neo-geo-family",
  name: "Neo Geo",
  brand: "SNK",
  type: "console",
  category: "Retro",
  variants: [
    {
      id: "neo-geo-home",
      name: "Neo Geo",
      versions: [
        {
          id: "neo-geo-aes",
          name: "Neo Geo AES",
          storage: "",
          disc: false,
          image: "/images/consoles/neo-geo-aes.png",
        },
        {
          id: "neo-geo-cd",
          name: "Neo Geo CD",
          storage: "",
          disc: true,
          image: "/images/consoles/neo-geo-cd.png",
        },
        {
          id: "neo-geo-mini",
          name: "Neo Geo Mini",
          storage: "",
          disc: false,
          mini: true,
          image: "/images/consoles/neo-geo-mini.png",
        },
      ],
    },

    {
      id: "neo-geo-portable",
      name: "Neo Geo Pocket",
      versions: [
        {
          id: "neo-geo-pocket",
          name: "Neo Geo Pocket",
          storage: "",
          disc: false,
          image: "/images/consoles/neo-geo-pocket.png",
        },
        {
          id: "neo-geo-pocket-color",
          name: "Neo Geo Pocket Color",
          storage: "",
          disc: false,
          image: "/images/consoles/neo-geo-pocket-color.png",
        },
      ],
    },
  ],
},

{
  id: "retro-misc",
  name: "Autres consoles rétro",
  brand: "Retro",
  type: "console",
  category: "Retro",
  variants: [
    {
      id: "retro-misc-home",
      name: "Consoles rétro",
      versions: [

        {
          id: "amiga-cd32",
          name: "Amiga CD32",
          storage: "",
          disc: true,
          image: "/images/consoles/amiga-cd32.png",
        },
        {
          id: "philips-cdi",
          name: "Philips CD-i",
          storage: "",
          disc: true,
          image: "/images/consoles/philips-cdi.png",
        },
        {
          id: "colecovision",
          name: "ColecoVision",
          storage: "",
          disc: false,
          image: "/images/consoles/colecovision.png",
        },
        {
          id: "intellivision",
          name: "Intellivision",
          storage: "",
          disc: false,
          image: "/images/consoles/intellivision.png",
        },
        {
          id: "vectrex",
          name: "Vectrex",
          storage: "",
          disc: false,
          image: "/images/consoles/vectrex.png",
        },
      ],
    },
  ],
},

{
        id: "3do-family",
        name: "3DO",
        brand: "3DO",
        type: "console",
        category: "Retro",
        variants: [
            {
            id: "3do-panasonic",
            name: "Panasonic",
            versions: [
                {
                id: "3do-fz1",
                name: "Panasonic REAL FZ-1",
                storage: "",
                disc: true,
                image: "/images/consoles/3do-fz1.png",
                },
                {
                id: "3do-fz10",
                name: "Panasonic REAL FZ-10",
                storage: "",
                disc: true,
                image: "/images/consoles/3do-fz10.png",
                },
            ],
            },

            {
            id: "3do-goldstar",
            name: "GoldStar",
            versions: [
                {
                id: "3do-goldstar",
                name: "GoldStar 3DO",
                storage: "",
                disc: true,
                image: "/images/consoles/3do-goldstar.png",
                },
            ],
            },

            {
            id: "3do-sanyo",
            name: "Sanyo",
            versions: [
                {
                id: "3do-sanyo-try",
                name: "Sanyo TRY 3DO",
                storage: "",
                disc: true,
                image: "/images/consoles/3do-sanyo.png",
                },
            ],
            },
        ],
        },

{
  id: "portable-misc",
  name: "Portables alternatives",
  brand: "Portable",
  type: "console",
  category: "Portable",
  variants: [
    {
      id: "portable-misc-family",
      name: "Portables",
      versions: [
        {
          id: "wonderswan",
          name: "WonderSwan",
          storage: "",
          disc: false,
          image: "/images/consoles/wonderswan.png",
        },
        {
          id: "wonderswan-color",
          name: "WonderSwan Color",
          storage: "",
          disc: false,
          image: "/images/consoles/wonderswan-color.png",
        },
        {
          id: "n-gage",
          name: "Nokia N-Gage",
          storage: "",
          disc: false,
          image: "/images/consoles/n-gage.png",
        },
      ],
    },
  ],
},
]